export const INPUT_PROPS = {
  name: 'email',
  label: 'Email of the user to login as',
  wrapperProps: {
    className: 'mt-2',
  },
};
